import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';

@Component({
  selector: 'app-glossary-term-topic',
  templateUrl: './glossary-term-topic.component.html'
})
export class GlossaryTermTopicComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();
  @Input() GlossaryTermData:any=[];
  topicData:any=[];
  topic:string="";
  
  constructor(private commonDataService: CommonDataService, private route: Router) {

  }

  publicationId: string = "";
  ngOnInit(): void {
    this.publicationId = localStorage.getItem("publicationId");
    this.topicData=this.GlossaryTermData;
    this.GetDistinctSubtopicRecords();
    this.topic=this.topicData[0].topic+" "+this.topicData[0].topicName
  }
  subtopicsRes:any=[];
  GetDistinctSubtopicRecords(){
    let count=0;
    this.topicData.forEach(element => {
      if(count==0){
        element.paranum = element.topic +"-"+ element.subtopic +"-"+ element.section;
        this.subtopicsRes.push(element);
        count++;
      }
      else{
        count++;
        var subtopicExists=this.subtopicsRes.filter(x=>x.subtopic==element.subtopic && x.section==element.section)
        if(subtopicExists.length==0){
          element.paranum = element.topic +"-"+ element.subtopic +"-"+ element.section;
          this.subtopicsRes.push(element);
        }
      }
    });
    this.subtopicsRes.sort((a, b) => (a.paranum?.toLowerCase().replace(/[^a-z0-9]/g, "") < b.paranum?.toLowerCase().replace(/[^a-z0-9]/g, "")) ? -1 : 1)
    
    this.topicData=this.subtopicsRes;
  }
  glossaryTermTitle:string="";
  navigateToContent(event, topicIdParam) {
    event.preventDefault();
    let topicId = topicIdParam;
    let url = this.publicationId+"/"+topicId;
    this.glossaryTermTitle=this.commonDataService.glossaryTermTopicGlossaryTitle.getValue();
    this.commonDataService.glossaryTermTopicGlossaryTitle.next("");
    this.commonDataService.glossaryTermFromContentPageBackButton.next(this.glossaryTermTitle);
    this.route.navigateByUrl(url);
    // this.route.navigateByUrl("1141285/1114044/919242/Overview and Background");
    this.commonDataService.NavigatingFromComponent.next("");
    this.commonDataService.childComponent.next(false);
    this.myEvent.emit();
  }

  mouseOverFunctions(event: any, topicId) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase().includes("glossaryterm")) {
      let url = this.publicationId + "/" + topicId;
      event.srcElement.setAttribute("href", "/" + url);
    }
  }

  ngOnDestroy():void{
    this.commonDataService.glossaryTermData.next([]);
  }
}
